import {RiDeleteBin5Fill} from "react-icons/ri";
import {BiEditAlt} from "react-icons/bi";

export const renderColumns = (handleApprove, handleReject) => {
    return [
        {
            dataIndex: "date",
            key: "date",
            title: "Tanggal & Waktu",
        },
        {
            dataIndex: "customer_name",
            key: "customer_name",
            title: "Nama Nasabah",
        },
        {
            dataIndex: "total_withdrawal",
            key: "total_withdrawal",
            title: "Jumlah Pencairan",
        },
        {
            dataIndex: "account_name",
            key: "account_name",
            title: "Nama Rekening",
        },
        {
            dataIndex: "action",
            key: "action",
            title: "Aksi",
            render: (_, record) => (
                <div className="text-center">
                    <div className="">
                        <button className="btn btn-sm bgc-41526E text-white" style={{width: 80}} onClick={() => handleApprove(record)}>Proses</button>
                    </div>
                    <div className="mt-1">
                        <button className="btn btn-sm btn-danger" style={{width: 80}} onClick={() => handleReject(record)}>Batalkan</button>
                    </div>
                </div>
            ),
        },
    ];
};
